import React from "react";
import { MessageServerConstant } from "../../../../constant/Types";
import MessageClient from "./MessageClient";
import MessageLawyer from "./MessageLawyer";
import VoiceMessageClient from "./VoiceMessageClient";
import VoiceMessageLawyer from "./VoiceMessageLawyer";
import { Spin } from "antd";
import { useSelector } from "react-redux";

export const SendType = {
  free: "free",
  text: "text",
  voice: {
    recoding: "voice-recoding", // start
    hold: "voice-hold",
    fixed: "voice-fixed", // open popup
    send: "voice-send",
    cancel: "voice-cancel",
  },
};

let waveSurfer = {};

const ChatHolder = () => {
  const { data: messages, loading } = useSelector((state) => state.pdfMessages);

  const ownerType = {
    client: "CLIENT",
    lawyer: "LAWYER",
  };

  function pauseAll(exclude = "") {
    for (const [key, value] of Object.entries(waveSurfer)) {
      if (key !== exclude) value.pause();
    }
  }

  return (
    <>
      <Spin spinning={loading}>
        <div className="pdfeditor__chat-holder">
          {messages.map((message, key) => {
            if (message.messageType === MessageServerConstant.text) {
              if (message.ownerType === ownerType.client) {
                return (
                  <MessageClient
                    key={`message-${message.id}`}
                    data={message.data}
                    time={message.time}
                    status={message.status}
                    meta={message}
                  />
                );
              } else {
                return (
                  <MessageLawyer
                    key={`message-${message.id}`}
                    data={message.data}
                    time={message.time}
                    status={message.status}
                    meta={message}
                  />
                );
              }
            } else if (message.messageType === MessageServerConstant.voice) {
              if (message.ownerType === ownerType.client) {
                return (
                  <VoiceMessageClient
                    key={key}
                    data={{
                      link: message.fileUrl,
                    }}
                    time={message.time}
                    status={"downloadable"}
                    pauseAll={pauseAll}
                    meta={message}
                    waveSurfer={waveSurfer}
                  />
                );
              } else {
                return (
                  <VoiceMessageLawyer
                    key={key}
                    data={{
                      link: message.fileUrl,
                    }}
                    time={message.time}
                    status={"downloadable"}
                    pauseAll={pauseAll}
                    meta={message}
                    waveSurfer={waveSurfer}
                  />
                );
              }
            }

            return <></>;
          })}
        </div>
      </Spin>
    </>
  );
};

export default ChatHolder;
